var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"label":_vm.label,"rules":[_vm.IsNum ].concat( _vm.rules),"value":_vm.myValue},on:{"input":_vm.InputEventQty}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }